// Copy a scan-purpose config and normalise its id.
// Camera scans store the id on `purposes`; the API stores it on `purpose`.
// Never write back onto the input — that object is often the react-query cache,
// and assigning `purpose = purposes` (undefined) wipes the id for every later scan.
export function clonePurposeConfig(config) {
  if (!config) return null;
  const purpose = config.purpose || config.purposes || null;
  return { ...config, purpose };
}

// Code to scan when Enter is pressed in the search box: an exact ID match or the only result,
// otherwise the raw input (a hardware scanner fires Enter before the debounced search returns).
export function pickSearchScanCode(input, searchedTerm, results = []) {
  const value = (input || '').trim();
  if (!value) return null;
  const current = (searchedTerm || '').trim() === value ? results : [];
  const exact = current.find((reg) => reg.userId?.toLowerCase() === value.toLowerCase());
  const match = exact || (current.length === 1 ? current[0] : null);
  return match ? match.userId : value;
}

// Hardware readers type a whole code within a few ms per key; people are far slower.
export const READER_KEY_GAP_MS = 35;
export function isReaderBurst(timestamps = [], minLength = 4) {
  if (timestamps.length < minLength) return false;
  const gaps = timestamps.slice(1).map((t, i) => t - timestamps[i]).sort((a, b) => a - b);
  return gaps[Math.floor(gaps.length / 2)] <= READER_KEY_GAP_MS;
}
